import OneTimePaymentContainer from "./OneTimePaymentContainer";
import OneTimePaymentStore from "./OneTimePaymentStore";

export default OneTimePaymentStore(OneTimePaymentContainer);